import React from 'react';

import ControlDates from 'components/FormDate/SummaryDatesList';

import ControlParticipants from './ControlParticipants';
import ControlDescription from './ControlDescription';
import ControlMap from './ControlMap';
import ControlText from './ControlText';
import ControlList from './ControlList';

const getActivitySchema = (activity, activityTypes = []) => activityTypes.find(({ key }) =>
  key.replace('onf.fms.', '') === activity.type.split(',')[1]);

export const switchControl = (activity, geojsonConflicts, data, activityTypes) =>
  getActivitySchema(activity, activityTypes).value.controls
    .map(({ type, name, ...controlProps }) => {
      const props = { activity, name, type, ...controlProps };
      const {
        description,
        participantCount,
        eventDates,
        publicCount,
      } = activity;

      switch (type) {
        case 'description':
          return <ControlDescription key={`${name}${type}`} description={description} />;
        case 'participants':
          return (
            <ControlParticipants
              key={`${name}${type}`}
              participants={participantCount}
              audience={publicCount}
            />
          );
        case 'dates':
          return <ControlDates key={`${name}${type}`} eventDates={eventDates} />;
        case 'location':
          return (
            <ControlMap
              key={`${name}${type}`}
              geojsonConflicts={geojsonConflicts}
              data={data}
              activity={activity}
              activityTypes={activityTypes}
            />
          );
        case 'text':
          return <ControlText key={`${name}${type}`} {...props} />;
        case 'list':
          return <ControlList key={`${name}${type}`} {...props} />;
        default:
          return null;
      }
    });

export default switchControl;



// WEBPACK FOOTER //
// ./src/components/Summary/Controls/index.js